import { Injectable } from '@angular/core';
import { HttpEvent, HttpResponse } from '@angular/common/http';
import { environment } from '../environments/environment';

import { Observable, throwError, of } from 'rxjs';

import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor
} from '@angular/common/http';
// import 'rxjs-compat/add/operator/do';
import { mergeMap, catchError, tap } from 'rxjs/operators';
import {
  AuthService,
  RequestCacheService
} from '@auth-suite-services/services';
// import { AuthService, RequestCacheService } from '@bank-suite.softplice.co.za/services';

const TTL = 30;

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(
    private cache: RequestCacheService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const cachedResponse = this.cache.get(req.url);
    console.log(`url: ${req.url}`);
    console.log(JSON.stringify(req.headers));

    return this.authService.getTokenSilently$().pipe(
      mergeMap((token) => {
        // console.log('token');
        // console.log(token);
        let tokenReq = req;
        console.log(req.headers);
        console.log('---------');

        if (req.headers.has('Authorization')) {
          console.log('Authorization');
        } else {
          console.log(`No Authorization Add Bearer Token ${token}`);
          tokenReq = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          });
        }

        tokenReq = tokenReq.clone({
          setHeaders: { appconsumer: environment.appconsumer }
        });

        if (isCachable(req)) {
          if (req.headers.has('DoNotIntercept')) {
            if (environment.debug) {
              console.log('CacheInterceptor -> DoNotIntercept');
            }

            console.log(
              `Intercept headers ${req.url} -- `,
              tokenReq.headers.keys()
            );
            console.log(`DoNotIntercept: ${req.headers.get('DoNotIntercept')}`);

            if (req.headers.get('DoNotIntercept') === 'false') {
              console.log(`cachedResponse ${req.url} -- `, cachedResponse);
              return cachedResponse
                ? of(cachedResponse)
                : this.sendRequest(tokenReq, next);
            } else {
              console.log(`DoNotIntercept false Sent to Server`);
              return this.sendRequest(tokenReq, next);
            }
          } else {
            console.log(`No DoNotIntercept header Sent to Server`);
            return this.sendRequest(tokenReq, next);
          }
        } else {
          console.log(`Not Cache'able Sent to Server`);
          return this.sendRequest(tokenReq, next);
        }

        // return next.handle(tokenReq);
      }),
      catchError((err) => throwError(err))
    );
  }

  sendRequest(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (environment.debug) {
      console.log('CacheInterceptor -> sendreq');
    }
    // if (environment.debug) { console.log('***************-> req:' + JSON.stringify(req)); }
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.cache.set(req.url, event, TTL);
        }
      })
    );
  }
}

function isCachable(req: HttpRequest<any>) {
  // Only GET requests are cachable
  return req.method === 'GET'; // &&
  // Only npm package search is cachable in this app
  // -1 < req.url.indexOf(searchUrl);
}
